import Star from './Star';
import styled from 'styled-components';

type StarRateProps = {
  defaultValue: number;
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
};

const defaultProps = {
  marginTop: '0rem',
  marginBottom: '0rem',
  marginLeft: '0rem',
  marginRight: '0rem',
};

const StarRateContainer = styled.div<StarRateProps>`
  display: flex;
  margin-top: ${(props): string | undefined => props.marginTop};
  margin-bottom: ${(props): string | undefined => props.marginBottom};
  margin-left: ${(props): string | undefined => props.marginLeft};
  margin-right: ${(props): string | undefined => props.marginRight};
`;

const StarRate = (props: StarRateProps): JSX.Element => {
  const { defaultValue } = props;
  return (
    <StarRateContainer {...props}>
      {[1, 2, 3, 4, 5].map((i) =>
        i <= defaultValue ? (
          <Star color="rated" key={`StarRate: ${i}`} />
        ) : (
          <Star color="unrated" key={`StarRate: ${i}`} />
        )
      )}
    </StarRateContainer>
  );
};

StarRate.defaultProps = defaultProps;

export default StarRate;
